import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { GameScene } from './scenes/GameScene';
import { UIScene } from './scenes/UIScene';
import { InventoryScene } from './scenes/InventoryScene';

/**
 * Build the Phaser game configuration.
 * @param {HTMLElement} parent - DOM element to attach the canvas to.
 */
export function createGameConfig(parent) {
  return {
    type: Phaser.AUTO,
    parent,
    pixelArt: false,
    roundPixels: false,
    backgroundColor: '#1a1a2e',
    input: {
      touch: true,
      activePointers: 2,
    },
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: '100%',
      height: '100%',
    },
    scene: [BootScene, GameScene, UIScene, InventoryScene],
  };
}
